import React, { useEffect, useMemo, useState } from 'react'
import { useQuery } from 'react-query'
import { Heading, Label, Layout } from '@staccx/bento'
import { RightAlignedRow } from '../../../theme/Theme.ItemGroup'
import DropDown from '../../../components/DropDownMenu'
import { TranslatedText } from '@staccx/i18n'
import InvoiceReportTable from '../components/InvoiceReportTable'
import { useFilterOnConsolidateAgreement } from '../hooks/useFilterOnConsolidateAgreement'
import { ConsolidateInvoiceSelect } from '../../../components/menu/ConsolidateInvoiceSelect'
import { useChosenCompany } from '../../../context/UserProvider'
import { fetchInvoiceReport } from '../../../api/api'
import ExcelButton from '../components/ExcelButton'
import Container from '../../../components/Container'

const InvoiceReport = () => {
  const company = useChosenCompany()
  const companyId = company && company.id

  const { data = [], status } = useQuery(['invoiceReport', companyId], () => fetchInvoiceReport(company.id), {
    enabled: !!companyId
  })

  const invoiceYears = useMemo(() => {
    return [...new Set(data.map((el) => new Date(el.postingDate).getFullYear()))]
  }, [data])

  const [year, yearSet] = useState(new Date().getFullYear())

  useEffect(() => {
    yearSet(invoiceYears[0])
  }, [invoiceYears.length])

  const agreementFilter = useFilterOnConsolidateAgreement()
  const options = invoiceYears.map((item) => ({ value: item, label: item }))
  const selected = { value: year, label: year }

  const mockInvoiceReport = [
    {
      invoiceNo: 'INV789',
      consolidateInvoiceCode: 'C1234 - Stacc',
      postingDate: '20.02.24',
      consolidateDescription: 'In progress',
      billToName: 'Alex Johnson'
    }
  ]

  return (
    <Container width="unlimited">
      <Layout rowGap={'small'}>
        <TranslatedText i18nKey={'INVOICEREPORT_HEADING'}>
          {(value) => <Heading level="1">{value}</Heading>}
        </TranslatedText>
        <Layout variant="fiftyFifty">
          <TranslatedText i18nKey="PERIOD">
            {(value) => (
              <div>
                <Label>{value}</Label>
                <DropDown value={selected} options={options} onChange={(selectedItem) => yearSet(selectedItem.value)} />
              </div>
            )}
          </TranslatedText>
          <ConsolidateInvoiceSelect />
        </Layout>
      </Layout>
      <RightAlignedRow>
        <ExcelButton />
      </RightAlignedRow>
      <InvoiceReportTable isLoading={status === 'loading'} data={mockInvoiceReport} />
    </Container>
  )
}

export default InvoiceReport
